import { SET_PRE_LOGIN_SHOWN } from "../constants/action-types";

export default (state = false, { type, preLoginShown }) => {
  if (type == SET_PRE_LOGIN_SHOWN) {
    return preLoginShown;
  } else {
    return state;
  }
};
